import { garageClient } from './client'
import type { ServiceConfigParam } from '../types'

export const getGarageConfig = () =>
  garageClient.get<ServiceConfigParam[]>('/config')

export const setGarageConfig = (key: string, value: string) =>
  garageClient.post('/config', { [key]: value })
